import { Button, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import TablaGeneral from "./components/tablageneral";
import CrearProducto from "./components/crearProducto";
import { GetAllPartes } from "../../../hooks/getAllPartes";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { useLoading } from "../../../components/Loading/useLoading";
import { SET_FILTRO } from "../../../redux/reducers/app.reducer";
import { useSearchParams } from "react-router-dom";

const IndexProducts = () => {


  const dispatch = useDispatch();
  const { setAppLoading } = useLoading();
  const { getAllPartesMutation } = GetAllPartes();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openNuevo, setOpenNuevo] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [partesFiltradas, setPartesFiltradas] = useState([]);
  const [searchTerm, setSearchTerm] = useState(searchParams.get('filter') ?? null);

  const get_data_tabla = (filter_value) => {
    setAppLoading(true);
    getAllPartesMutation(filter_value, {
      onSuccess: (data) => {
        setPartesFiltradas(data)
        setAppLoading(false);
      },
      onError: (error) => {
        console.log(error)
        setAppLoading(false);
      }
    })
  }

  useEffect(() => {
    dispatch(
      HEADER_DATA_UPDATE({ nombreData: null }),
    );
    if (searchTerm) {
      setFiltro(searchTerm);
      get_data_tabla(searchTerm);
    }
  }, []);

  const handleInputChange = (event) => {
    setFiltro(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleFilterChange('filter', filtro);
      get_data_tabla(filtro)
    }
  };

  const handleFilterChange = (key, value) => {
    setSearchParams(prevParams => {
      if (value) {
        prevParams.set(key, value);
      } else {
        // Si el valor está vacío, eliminamos el parámetro de la URL
        prevParams.delete(key);
      }
      return prevParams;
    });
  };



  return (
    <>
      <Grid container spacing={0} sx={{ height: '10vh' }}>
        <Grid item xs={3} sm={3} md={3} lg={2} xl={2} sx={{ padding: '10px 30px', height: '100%' }} className="center_item">
          <Button
            variant="contained"
            className="btn_system"
            onClick={() => setOpenNuevo(true)}>
            Crear
          </Button>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={0} sx={{ height: '70vh' }}>
        <Grid item xs={12} sx={{ padding: '10px 20px', height: '100%' }} className="center_item">
          <TablaGeneral key={'table_gen'} sample={partesFiltradas} filtro={filtro} handleInputChange={handleInputChange} onPressEnter={handleKeyDown} />
        </Grid>
      </Grid>
      <CrearProducto key={'modal_nuevo_prod'} open={openNuevo} setOpen={setOpenNuevo} />
    </>
  )
}

export default IndexProducts;